import {normalizarPoliticaRol,permiteRol,tieneReservaGlobal} from './permisosRol';

// src/utils/eventAccess.js
import { collection, documentId, query, where, doc } from 'firebase/firestore';
import { getDocs, getDoc, getDocFromServer } from './firestoreRead';
import { auth, db } from "../firebase/firebaseConfig";
import { perfilOperativo } from "./authProfile";
import { empresasDelPerfil, puedeAccederEvento, excepcionesEvento, flagsPermiten, rolPermiteModulo } from "./accessPolicy";

import { normalizarRol } from './roles';
import { leerUsuario, leerEvento } from './legacyData';



export const normalizarEmpresasPermitidas = empresasDelPerfil;

export async function obtenerPerfilActual() {
  const user = auth.currentUser;

  if (!user) {
    return {
      user: null,
      perfil: null,
      rol: "pendiente",
      eventosPermitidos: {},
      eventosBloqueados: {},
      empresaId: "",
      empresaNombre: "",
      empresasPermitidas: [],
    };
  }

  const ref = doc(db, "usuarios", user.uid);
  const snap = await getDocFromServer(ref);

  let perfil = snap.exists() ? leerUsuario(snap.data(), user.uid) : null;
  if (!perfilOperativo(perfil)) {
    return { user, perfil, rol: "pendiente", eventosPermitidos: {}, eventosBloqueados: {}, empresaId: "", empresaNombre: "", empresasPermitidas: [] };
  }
  const config=await getDocFromServer(doc(db,'configuracion','roles'));perfil={...perfil,politicaRol:config.exists()?normalizarPoliticaRol(perfil.rol,config.data().roles?.[perfil.rol]):null};
  const rol = normalizarRol(perfil?.rol);
  const eventosPermitidos = perfil?.eventosPermitidos || {};
  const eventosBloqueados = perfil?.eventosBloqueados || {};
  const empresaId = perfil?.empresaId || '';
  const empresaNombre = perfil?.empresaNombre || "";
  const empresasPermitidas = normalizarEmpresasPermitidas(perfil || {});

  return { user, perfil, rol, eventosPermitidos, eventosBloqueados, empresaId, empresaNombre, empresasPermitidas };
}

export function usuarioPuedeAccederEvento({ rol, eventosPermitidos, eventosBloqueados, eventoId, permiso, evento, empresaId, empresasPermitidas, activo = true,politicaRol=null }) {
  if (!evento) return false;
  return puedeAccederEvento({ rol, activo,politicaRol, empresaId, ...(empresasPermitidas !== undefined ? { empresasPermitidas } : {}), eventosPermitidos, eventosBloqueados }, { ...evento, id: eventoId }, permiso);
}

export async function verificarAccesoEvento(eventoId, permiso) {
  const { user, perfil, rol, eventosPermitidos, eventosBloqueados, empresaId, empresasPermitidas } = await obtenerPerfilActual();

  if (!user) {
    return { permitido: false, motivo: "NO_AUTH", user: null, rol, eventosPermitidos, perfil };
  }

  if (!perfilOperativo(perfil)) {
    return { permitido: false, motivo: perfil?.activo === false ? "USUARIO_DESACTIVADO" : "SIN_PERFIL", user, perfil, rol, eventosPermitidos };
  }

  let evento = null;
  if (eventoId) {
    try {
      const eventoSnap = await getDoc(doc(db, "eventos", eventoId));
      evento = eventoSnap.exists() ? { id: eventoSnap.id, ...eventoSnap.data() } : null;
    } catch (error) {
      console.warn("No se pudo consultar el evento para validar empresa:", error);
    }
  }

  const permitido = usuarioPuedeAccederEvento({
    rol,
    eventosPermitidos,
    eventosBloqueados,
    eventoId,
    permiso,
    evento,
    empresaId,
    empresasPermitidas,
    activo: perfil.activo,politicaRol:perfil.politicaRol,
  });

  return {
    permitido,
    motivo: permitido ? "OK" : "SIN_PERMISO",
    user,
    perfil,
    rol,
    eventosPermitidos,
    eventosBloqueados,
    empresaId,
    empresasPermitidas,
    evento,
  };
}

export function eventoDisponibleParaModulo(evento, tipoArte = "general") {
  if (tipoArte === "entradas") {
    return evento?.entradasHabilitadas !== false && !!(evento?.arteEntrada);
  }

  if (tipoArte === "invitaciones") {
    return evento?.invitacionesConfig?.habilitadas !== false && !!evento?.arteInvitacion;
  }

  return true;
}

export function filtrarEventosPorPermiso(eventos, rol, eventosPermitidos, permiso, perfil = {}, tipoArte = 'general') {
  return eventos.filter((evento) => (permiso!=="reservas"||evento.reservasHabilitadas!==false) && eventoDisponibleParaModulo(evento, tipoArte) &&
    puedeAccederEvento({ ...perfil, rol, eventosPermitidos }, evento, permiso));
}

// Owner es el único lector global. Las queries de empresa excluyen excepciones
// por ID: Rules no filtra resultados y no se descargan eventos bloqueados.
export async function obtenerEventosAccesibles(permiso = 'general', accesoActual = null) {
  const acceso = accesoActual || await obtenerPerfilActual();
  const { user, perfil, rol } = acceso;
  if (!user || !perfilOperativo(perfil) || !rolPermiteModulo(rol, permiso,perfil)) return [];
  const ordenar = (items) => items.sort((a, b) => String(b.fechaInicio || '').localeCompare(String(a.fechaInicio || '')));
  const eventosRef = collection(db, 'eventos');
  if(permiso==='reservas'&&rol!=='owner'&&tieneReservaGlobal(perfil)){const {listarEventosReservas}=await import('./reservasPrivadas');return ordenar(await listarEventosReservas());}
  if (rol === 'owner'||permiteRol(perfil,'eventos.gestionar')) {
    const snap = await getDocs(eventosRef);
    return ordenar(snap.docs.map((d) => (leerEvento(d.data(), d.id))));
  }
  const ids = excepcionesEvento(perfil);
  const encontrados = new Map();
  const read = async (filters) => {
    const snap = await getDocs(query(eventosRef, ...filters));
    snap.docs.forEach((d) => encontrados.set(d.id, { ...d.data(), id: d.id }));
  };
  const empresas = empresasDelPerfil(perfil);
  if (empresas.length && ids.length > 10) {
    const error = new Error('Este perfil tiene más de 10 excepciones de eventos. El listado por empresa está bloqueado; usa un acceso directo autorizado o contacta al Owner.');
    error.code = 'access/too-many-event-exceptions';
    throw error;
  }
  for (const empresa of empresas) {
    const filters = [where('empresaId', '==', empresa)];
    if (ids.length) filters.push(where(documentId(), 'not-in', ids));
    await read(filters);
  }
  for (const id of ids) {
    if (perfil.eventosBloqueados?.[id] === true) continue;
    const flags = perfil.eventosPermitidos?.[id];
    if (Object.prototype.hasOwnProperty.call(perfil.eventosPermitidos || {}, id) && !flagsPermiten(rol, flags, permiso)) continue;
    try {
      const snap = await getDocFromServer(doc(db, 'eventos', id));
      if (snap.exists()) encontrados.set(id, { ...snap.data(), id });
    } catch (error) {
      if (error.code !== 'permission-denied') throw error;
      // Una asignación obsoleta no autoriza a leer el documento.
    }
  }
  return ordenar([...encontrados.values()].filter((evento) => puedeAccederEvento(perfil, evento, permiso)));
}

async function conPoliticasUsuarios(rows,database){const snap=await getDocFromServer(doc(database,'configuracion','roles'));const roles=snap.exists()?snap.data().roles||{}:{};return rows.map(p=>({...p,politicaRol:normalizarPoliticaRol(p.rol,roles[p.rol])}));}

export async function obtenerUsuariosDelAlcance(accesoActual = null, database = db) {
  const acceso = accesoActual || await obtenerPerfilActual();
  if (!acceso.user || !perfilOperativo(acceso.perfil)) return [];
  const usuarios = collection(database, 'usuarios');
  if (acceso.rol === 'owner'||permiteRol(acceso.perfil,'usuarios.gestionar')||permiteRol(acceso.perfil,'empresas.gestionar')) {
    const snap = await getDocs(usuarios);
    return snap.docs.map((d) => ({ ...d.data(), id: d.id }));
  }
  if (!['socio', 'organizador', 'administracion', 'rrpp', 'imagen','porteria','barra'].includes(acceso.rol)) return [];
  const map = new Map([[acceso.user.uid, { ...acceso.perfil, id: acceso.user.uid }]]);
  for (const id of empresasDelPerfil(acceso.perfil)) {
    const snap = await getDocs(query(usuarios, where('empresaId', '==', id)));
    snap.docs.forEach((d) => map.set(d.id, { ...d.data(), id: d.id }));
  }
  return conPoliticasUsuarios([...map.values()],database);
}

export async function obtenerEmpresasDelAlcance(accesoActual = null) {
  const acceso = accesoActual || await obtenerPerfilActual();
  if (!acceso.user || !perfilOperativo(acceso.perfil)) return [];
  if (acceso.rol === 'owner') {
    const snap = await getDocs(collection(db, 'empresas'));
    return snap.docs.map((d) => ({ ...d.data(), id: d.id }));
  }
  const result = [];
  for (const id of empresasDelPerfil(acceso.perfil)) {
    const snap = await getDocFromServer(doc(db, 'empresas', id));
    if (snap.exists()) result.push({ ...snap.data(), id });
  }
  return result;
}

export function obtenerArteEvento(evento, tipo = "general") {
  let arte = "";

  if (tipo === "entradas") {
    arte = evento?.arteEntrada || "";
  } else if (tipo === "invitaciones") {
    arte =
      evento?.arteInvitacion ||
      "";
  } else {
    arte = evento?.arteInvitacion || evento?.arteEntrada || "";
  }

  if (!arte) return "";
  if (arte.startsWith("http")) return arte;
  if (arte.startsWith("/eventos/")) return arte;
  return `/eventos/${arte.replace(/^\//, "")}`;
}
